import { Helmet } from "react-helmet-async";

/**
 * Per-page SEO wrapper — sets unique title, meta description, canonical URL,
 * Open Graph + Twitter card tags. Crawlers like Googlebot execute JS so these
 * dynamic tags are picked up; the static sitemap.xml + robots.txt + per-page
 * Helmet combine for solid organic SEO.
 *
 * Note: Real SSR (Next.js) would be ideal, but for this CRA app this hybrid
 * approach (helmet + sitemap + static prerendered hero in index.html) gives
 * 90% of the SEO value without a framework migration.
 */
const SITE_NAME = "Weddinsite";
const SITE_BASE = "https://weddinsite.com";
const DEFAULT_OG = "https://static.prod-images.emergentagent.com/jobs/e2e0434f-791b-4946-9107-bbcacc2f5654/images/eb9826a0a0b0673974530290ced0be90536ee38e7dc459ba43154c5f59838470.png";

export default function SEO({
  title,
  description,
  path = "",
  image = DEFAULT_OG,
  noindex = false,
  jsonLd = null,
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const canonical = `${SITE_BASE}${path.startsWith("/") ? path : "/" + path}`.replace(/\/+$/, "") || SITE_BASE;
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
